// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WEBPUSH_NOTIFICATIONS_SUBSCRIBED_DESKTOP = "Zapnula si upozorn\u011bn\u00ed v prohl\u00ed\u017ee\u010di.";
export const WEBPUSH_NOTIFICATIONS_SUBSCRIBED_MOBILE = "Zapnula si upozorn\u011bn\u00ed v mobilu.";
